export const isNotUndefined = (value: any) => {
  if (value === undefined || value === null) return false
  return true
}
